import { render, staticRenderFns } from "./p16.vue?vue&type=template&id=46d5f1ba&scoped=true&"
import script from "./p16.vue?vue&type=script&lang=js&"
export * from "./p16.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d5f1ba",
  null
  
)

export default component.exports